import { useMemo } from 'react';
import * as yup from 'yup';

import { FORM_LINE_TYPES } from 'src/components/ui/FormLine/constants';

export const useFormRemoveArea = (params = {}) => {
	const { values, options = [] } = params;

	const initialValues = useMemo(() => {
		return {
			areas: [],
			...values,
		};
	}, [values]);

	const shape = useMemo(() => {
		return {
			groups: [
				{
					id: 1,
					lines: [
						{
							id: 1,
							field: {
								id: 1,
								type: FORM_LINE_TYPES.checkbox,
								connected: true,
								params: {
									label: 'Выберите площадку',
									name: 'areas',
									options,
								},
							},
						},
					],
				},
			],
		};
	}, [options]);

	const validationSchema = yup.object().shape({
		areas: yup.array().min(1, 'Выберите площадку'),
	});

	return { shape, initialValues, validationSchema };
};
